// extracted by mini-css-extract-plugin
module.exports = {"balloon":"BalloonMessage_balloon__22lli","character":"BalloonMessage_character__3M5C3"};